import React from "react";
import { useState } from "react";

import { FormControlDollarBox } from "../../";
import { useDeepEffect } from "../../../abstracts";

const FieldInputDollarBox = ({
  field,
  form,
  onChange,
  preventNegative,
  precision,
  value,
  ...rest
}) => {
  let prevValue;
  const { max = 99999999999.99 } = rest;
  // value = parseFloat(value)?.toFixed(2);
  const countDecimals = function (value) {
    if (Math.floor(value) === value) return 0;
    return value?.toString()?.split(".")[1]?.length || 0;
  };
  const [val, setVal] = useState();
  // console.log("psdcsd", value);
  useDeepEffect(() => {
    if (precision && countDecimals(value) > precision) {
      setVal(value?.toFixed(2));
    } else setVal(value);
  }, [value]);

  return (
    <FormControlDollarBox
      {...field}
      {...form}
      precision={precision}
      {...rest}
      autoComplete="off"
      type="number"
      step="any"
      onKeyDown={(evt) => {
        if (!preventNegative && (evt.key === "e" || evt.key === "E")) {
          evt.preventDefault();
        } else if (
          preventNegative &&
          (evt.key === "e" || evt.key === "E" || evt.key === "-")
        ) {
          evt.preventDefault();
        }
        prevValue = evt.target.value;
      }}
      onChange={(evt) => {
        if (
          (precision && countDecimals(evt.target.value) > precision) ||
          evt.target.value > max
        ) {
          evt.target.value = prevValue;
        } else if (
          (!precision && countDecimals(evt.target.value) > 2) ||
          evt.target.value > max
        ) {
          evt.target.value = prevValue;
        }
        onChange(evt);
      }}
      value={val}
    />
  );
};

export default FieldInputDollarBox;
